import React, { useState } from 'react';
import { useMapVisibilityFeature } from '../hooks/useFeatureFlags';
import Spinner from './Spinner';
import AlertMessage from './AlertMessage';
import './FeatureConfig.css';

const FeatureConfig = () => {
  const { featureData, loading, error, updating, updateFeature } = useMapVisibilityFeature();
  const [description, setDescription] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleToggleChange = async (enabled) => {
    try {
      setSuccessMessage('');
      await updateFeature(enabled, description);
      setSuccessMessage(`Mapa ${enabled ? 'habilitado' : 'deshabilitado'} exitosamente`);
      setDescription(''); // Clear description after successful update
    } catch (err) {
      // Error is already handled in the hook
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('es-AR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Configuración</h2>
      </div>

      {error && (
        <AlertMessage 
          type="danger" 
          message={error}
          onClose={() => {}} 
        />
      )}
      
      {successMessage && (
        <AlertMessage 
          type="success" 
          message={successMessage}
          onClose={() => setSuccessMessage('')} 
        />
      )}

      <div className="feature-item">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 className="feature-title">Visibilidad del Mapa</h6>
            <p className="feature-description text-muted mb-0">
              Controla si el mapa de pizzerías está visible para los usuarios
            </p>
          </div>
          <div className="toggle-switch">
            <input
              type="checkbox"
              id="mapVisibility"
              className="toggle-input"
              checked={featureData?.enabled || false}
              onChange={(e) => handleToggleChange(e.target.checked)}
              disabled={updating}
            />
            <label htmlFor="mapVisibility" className="toggle-label">
              <span className="toggle-inner"></span>
              <span className="toggle-switch"></span>
            </label>
          </div>
        </div>


        {featureData && (
          <div className="feature-info">
            <div className="row">
              <div className="col-md-6">
                <small className="text-muted">
                  <strong>Estado actual:</strong> {featureData.enabled ? 'Habilitado' : 'Deshabilitado'}
                </small>
              </div>
              <div className="col-md-6">
                <small className="text-muted">
                  <strong>Última actualización:</strong> {formatDate(featureData.lastUpdated)}
                </small>
              </div>
            </div>
            {featureData.updatedBy && (
              <div className="row mt-1">
                <div className="col-12">
                  <small className="text-muted">
                    <strong>Actualizado por:</strong> {featureData.updatedBy}
                  </small>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default FeatureConfig;